import React, { Component } from 'react';
import cn from 'classnames';
import _ from 'lodash';
import Video from 'legacy-src/utility/Video';
import btn from 'legacy/src/utility/btn';
import RichText from 'legacy-src/utility/RichText';
import responsiveElementEnhancer from 'legacy/src/components/enhancers/ResponsiveElementEnhancer';

import { getSignedUrl } from 'legacy/src/shared/clients/apiClient';
import './video.scss';

function videoType(url) {
  return url.split('.').slice(-1)[0].replace(/\?.*$/, '');
}

class Player extends Component {
  static breakpoints = {
    small: (e) => e.width < 745,
    default: (e) => e.width >= 745,
  };

  constructor(props) {
    super(props);

    const {
      item: { content },
    } = props;
    this.state = {
      loading: true,
      srcs: content.srcs,
      breakpoints: { default: true },
    };

    this._toggleTranscript = this._toggleTranscript.bind(this);
    this.timeUpdate = this.timeUpdate.bind(this);
  }

  _toggleTranscript() {
    if (this.state.transcriptOpen) {
      this.setState({ transcriptOpen: false, closing: true });
      setTimeout(() => this.setState({ closing: false }), 500);
    } else {
      this.setState({ transcriptOpen: true });
    }
  }

  timeUpdate(ev) {
    const self = this;

    if (!this._timeUpdate) {
      this._timeUpdate = _.throttle((ev) => {
        const { submission } = self.props;
        const state = submission.state || {};
        const currentTime = ev.target.currentTime;
        const totalTime = Math.max(state.totalTime || 0, currentTime);
        if (currentTime !== state.currentTime) {
          submission.setState({
            currentTime,
            totalTime,
            totalComplete:
              (ev.target.duration - totalTime > 2
                ? totalTime
                : ev.target.duration) / ev.target.duration || 0,
          });
        }
      }, 1000);
    }
    this._timeUpdate(ev);
  }

  _loadData(s3Key) {
    if (!this._loadData.cache) this._loadData.cache = {};
    const url = '';

    if (!this._loadData.cache[url]) {
      this._loadData.cache[url] = Promise.all(
        ['.mp4', '.webm'].map((suffix) =>
          getSignedUrl(`//media.academicmerit.com/${s3Key}/720p${suffix}`),
        ),
      ).then((results) => {
        this.setState({ srcs: results, loading: false });
        delete this._loadData.cache[url];
      });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      item: { content },
    } = nextProps;
    if (content.s3Key && content.s3Key !== prevState.originalKey) {
      return {
        loading: true,
        srcs: null,
        originalKey: content.s3Key,
      };
    }
    return null;
  }

  componentDidUpdate() {
    const {
      item: { content },
    } = this.props;
    if (content.s3Key && this.state.srcs === null) {
      this._loadData(content.s3Key);
    }
  }

  render() {
    const {
      item: { content },
      submission,
    } = this.props;
    const state = submission.state || {};
    const breakpoints = this.state.breakpoints;
    const events = {
      timeupdate: this.timeUpdate,
    };
    const { loading, srcs } = this.state;
    const videoElem = loading ? null : (
      <Video events={events} startTime={state.currentTime}>
        {srcs.map((src, index) => (
          <source src={src} type={`video/${videoType(src)}`} key={index} />
        ))}
        <track
          kind="captions"
          src={content.captions}
          srcLang="en"
          label="English"
          default
        />
      </Video>
    );

    return (
      <div
        className={cn('video__content', [breakpoints])}
        data-am-type="media/video"
      >
        <div className="video__wrapper cf">
          {videoElem}
          {content.transcript ? (
            <button
              className={cn(
                'video__transcript-toggle',
                btn({ color: 'gray' }),
                { red: this.state.transcriptOpen },
              )}
              onClick={this._toggleTranscript}
            >
              {this.state.transcriptOpen
                ? 'Close transcript'
                : 'Show transcript'}
            </button>
          ) : null}
        </div>
        <div
          className={cn('video__transcript', {
            'video__transcript--open': this.state.transcriptOpen,
          })}
        >
          <RichText content={content.transcript} />
        </div>
      </div>
    );
  }
}

Player.displayName = 'Video';

const status = (item, state = {}) => ({
  viewed: state.viewed ? 1 : 0,
  complete: state.totalComplete || 0,
});

const component = responsiveElementEnhancer(Player);
export default { component, status };
